<template>
    <div>
        <div id="container" style="min-width: 343px; height: 250px; margin: 0 auto" />
    </div>
</template>

<script>
export default {
    props: {
        crossTypeName: {
            type: String,
            default: "All"
        },
        yearlyYieldChartData: {
            type: Object
        }
    },
    data() {
        return {
            dataArr: [],

            collectedFrom: null,
            collectedTo: null,
            yearlyYieldChart: null,
        };
    },
    computed: {
        chartTitle() {
            let crossType = this.crossTypeName ? `for ${this.crossTypeName}` : "";
            return `Yield Data Mean ${crossType} from ${this.collectedFrom} to ${this.collectedTo}`;
        }
    },
    watch: {
        yearlyYieldChartData() {
            if (this.yearlyYieldChartData) {
                this.refreshData();
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                var yearlyData = this.yearlyYieldChartData.yearData;
                this.collectedFrom = yearlyData[0][0];
                this.collectedTo = yearlyData[yearlyData.length - 1][0];
                this.drawChart();
            }, 100);
        });
    },
    methods: {
        refreshData() {
            console.log("refresh data", this.yearlyYieldChart);
            if (this.yearlyYieldChart) {
                this.yearlyYieldChart.setTitle({ text: this.chartTitle || "-" });
                this.yearlyYieldChart.xAxis[0].update({ categories: this.yearlyYieldChartData.yearData });
                this.yearlyYieldChart.xAxis[0].update({ plotBands: this.getPlotBand() });
                this.yearlyYieldChart.series[0].update({ data: this.yearlyYieldChartData.ffbData }, true);
                this.yearlyYieldChart.series[1].update({ data: this.yearlyYieldChartData.abwData }, true);
                this.yearlyYieldChart.series[2].update({ data: this.yearlyYieldChartData.bnoData }, true);
            }
        },
        getPlotBand() {
            return [{ // Best 4 Consecutive Years
                from: this.getBandYearFrom(),
                to: this.getBandYearTo(),
                color: "rgba(242, 125, 107, .4)",
                label: { 
                    text: "Best FFB for 4 Consecutive Years (" + this.yearlyYieldChartData.top4ConsecutiveYearFrom + "-" + this.yearlyYieldChartData.top4ConsecutiveYearTo + ")",
                    style: {
                        fontWeight: "bold",
                        fontSize: "10px",
                    }
                }
            }];
        },
        getBandYearFrom() {
            var yearData = this.yearlyYieldChartData.yearData.flat();
            var yearFrom = this.yearlyYieldChartData.top4ConsecutiveYearFrom;
            var index; 
            if (yearFrom) {
                index = yearData.indexOf(yearFrom);
                index -= 0.5;
            }
            return index; 
        },
        getBandYearTo() {
            var yearData = this.yearlyYieldChartData.yearData.flat();
            var yearTo = this.yearlyYieldChartData.top4ConsecutiveYearTo;
            var index; 
            if (yearTo) {
                index = yearData.indexOf(yearTo);
                index += 0.5;
            }
            return index; 
        },
        drawChart() {
            console.log("draw chart");
            var self = this;
            this.yearlyYieldChart = Highcharts.chart("container", {
                chart: {
                    type: "column"
                },
                title: {
                    text: self.chartTitle,
                    style: {
                        fontSize: "12px",
                    }
                },
                xAxis: {
                    type: "category",
                    categories: self.yearlyYieldChartData.yearData,
                    labels: {
                        rotation: -45,
                        style: {
                            fontSize: "12px",
                            fontFamily: "Verdana, sans-serif"
                        }
                    },
                    plotBands: self.getPlotBand()
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "Mean value"
                    }
                },
                legend: {
                    enabled: false,
                },
                tooltip: {
                    shared: true,
                    valueDecimals: 2,
                },
                plotOptions: {
                    series: {
                        groupPadding: 0,
                    }
                },
                series: [{
                    name: "FFB",
                    data: [...self.yearlyYieldChartData.ffbData],
                    dataLabels: {
                        enabled: true,
                        rotation: -90,
                        color: "#FFFFFF",
                        align: "right",
                        format: "{point.y:.2f}", // one decimal
                        y: 10, // 10 pixels down from the top
                        style: {
                            fontSize: "13px",
                            fontFamily: "Verdana, sans-serif"
                        }
                    }
                },
                {
                    name: "ABW",
                    type: "spline",
                    data: [...self.yearlyYieldChartData.abwData],
                },
                {
                    name: "BNO",
                    type: "spline",
                    data: [...self.yearlyYieldChartData.bnoData],
                }
                
                ]
            });
        }
    }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Chart/Best4ConsecutiveYearSmall.vue